import { h } from "preact";
import styles from "./Spinner.module.css";
import spinner from "../../assets/icons/spinner.svg";

const Spinner = ({ className }) => (
  <img className={[styles.spinner, className].join(" ")} src={spinner} />
);

export default Spinner;
